export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">关于我们</h2>
            <p className="mt-2 text-sm text-foreground-500">了解网红黑料平台的使命与坚持</p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="rounded-2xl bg-background-200/70 border border-background-300/40 p-8 md:p-10">
              <p className="text-sm text-foreground-600 leading-relaxed">
                网红黑料成立于2024年，是国内最专业的网红八卦资讯聚合平台之一。
                我们致力于为吃瓜群众提供真实、全面、及时的抖音网红黑料和快手网红黑料。
              </p>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                在网红经济高速发展的今天，信息不对称导致大量粉丝被虚假人设蒙蔽。
                我们坚持独立、客观的报道立场，深度挖掘大号扒皮内幕与塌房翻车丑闻，
                帮助公众了解网红群体最真实的一面。我们的编辑团队由资深媒体人和数据分析师组成，
                用专业方法让网红黑料报道有据可依。
              </p>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                从成立至今，平台已积累了500+网红的跟踪档案，发布了数千篇网红黑料报道，
                累计服务超过10万名活跃吃瓜用户。未来我们将持续扩大平台覆盖范围，
                提升信息时效性和准确性，做全网吃瓜用户最值得信赖的网红黑料第一站。
              </p>

              <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
                <div className="text-center p-4 rounded-lg bg-background-100/70">
                  <p className="text-2xl font-heading text-primary-500">500+</p>
                  <p className="mt-1 text-xs text-foreground-400">网红档案</p>
                </div>
                <div className="text-center p-4 rounded-lg bg-background-100/70">
                  <p className="text-2xl font-heading text-accent-500">3000+</p>
                  <p className="mt-1 text-xs text-foreground-400">爆料文章</p>
                </div>
                <div className="text-center p-4 rounded-lg bg-background-100/70">
                  <p className="text-2xl font-heading text-primary-500">10w+</p>
                  <p className="mt-1 text-xs text-foreground-400">活跃用户</p>
                </div>
                <div className="text-center p-4 rounded-lg bg-background-100/70">
                  <p className="text-2xl font-heading text-accent-500">2年</p>
                  <p className="mt-1 text-xs text-foreground-400">稳定运营</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}